import { render, staticRenderFns } from "./ReportsDashboard.vue?vue&type=template&id=3f65222f&scoped=true&"
import script from "./ReportsDashboard.vue?vue&type=script&lang=js&"
export * from "./ReportsDashboard.vue?vue&type=script&lang=js&"
import style0 from "./ReportsDashboard.vue?vue&type=style&index=0&id=3f65222f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f65222f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardSubtitle,VCardTitle,VCol,VRow})
